<template>
  <div>
    <SolicitarPermisoDisfrute
      v-if="mostrarFormulario"
      :datos_empleado="datos_empleado"
      :id_solicitud="idSolicitudEditar"
      :datos_solicitud_editar="solicitudEditar"
      :motivo_rechazo="motivoRechazo"
      :catalogos="catalogos"
      @regresar="manejarRegresarFormulario"
    />

    <v-container
      fluid
      tag="section"
      class="mt-4 bg-white border rounded shadow solicitudes-permisos-page"
      v-else-if="loading"
    >
      <v-row>
        <v-col cols="12" class="d-flex justify-center align-center solicitudes-permisos-loading">
          <v-progress-circular indeterminate color="primary" size="100" />
        </v-col>
      </v-row>
    </v-container>

    <v-container
      fluid
      tag="section"
      class="mt-4 bg-white border rounded shadow solicitudes-permisos-page"
      v-else-if="accesoPermitido"
    >
      <v-row justify="center">
        <v-row>
          <v-col cols="12" class="text-center mb-2">
            <h4 class="mb-1">SOLICITUDES DE PERMISOS / DÍAS DE DISFRUTE</h4>
            <p class="mb-0 text-body-2 text-secondary">
              Solicita tus permisos con al menos 3 días naturales de anticipación.
            </p>
            <p
              v-if="!hayConceptosDisponibles"
              class="mb-0 mt-2 text-body-2 font-weight-bold text-warning"
            >
              NO HAY PERIODOS ACTIVOS.
            </p>
            <div v-if="saldosPorConcepto.length" class="mt-2">
              <p
                v-for="item in saldosPorConcepto"
                :key="item.clave"
                class="mb-0 text-body-2"
              >
                {{ item.etiqueta }}: <strong>{{ item.dias }}</strong>
              </p>
            </div>
          </v-col>

          <v-col cols="12" sm="6" v-if="puedeSolicitar">
            <v-btn
              color="primary"
              block
              class="text-caption text-sm-body-2"
              @click="solicitarPermisoVista()"
            >
              <v-icon start>mdi-plus</v-icon>
              <span class="d-none d-sm-inline">SOLICITAR PERMISO</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col v-if="showTable" cols="12" sm="12">
            <v-client-table :data="dataSolicitudes" :columns="columns" :options="options">
              <template slot="estatus" slot-scope="props">
                <span v-if="props.row.id_estatus == 4" class="badge bg-info text-dark">
                  {{ props.row.estatus }}
                </span>
                <span v-else-if="props.row.id_estatus == 1" class="badge bg-warning text-dark">
                  {{ props.row.estatus }}
                </span>
                <span v-else-if="props.row.id_estatus == 2" class="badge bg-success">
                  {{ props.row.estatus }}
                </span>
                <span v-else-if="props.row.id_estatus == 3" class="badge bg-danger">
                  {{ props.row.estatus }}
                </span>
                <span v-else-if="props.row.id_estatus == 5" class="badge bg-secondary text-white">
                  {{ props.row.estatus }}
                </span>
                <span v-else class="badge bg-secondary">
                  {{ props.row.estatus }}
                </span>
              </template>
              <template slot="acciones" slot-scope="props">
                <v-menu v-if="tieneAccionesDisponibles(props.row)" bottom right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-if="props.row.id_estatus == 4"
                      @click="generar_formato_solicitud_permiso(props.row)"
                    >
                      <v-list-item-icon>
                        <v-icon class="text-info">mdi-file-pdf-box</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>GENERAR FORMATO</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="props.row.id_estatus == 4"
                      @click="abrirModalCargarFormato(props.row)"
                    >
                      <v-list-item-icon>
                        <v-icon class="text-primary">mdi-upload</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>CARGAR FORMATO A LA SOLICITUD</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="puedeEliminarSolicitud(props.row)"
                      @click="eliminarSolicitud(props.row)"
                    >
                      <v-list-item-icon>
                        <v-icon class="text-danger">mdi-delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>ELIMINAR</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="props.row.id_estatus == 3"
                      @click="editarSolicitud(props.row)"
                    >
                      <v-list-item-icon>
                        <v-icon class="text-warning">mdi-pencil</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>CORREGIR SOLICITUD</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-client-table>
          </v-col>
        </v-row>
      </v-row>

      <v-dialog v-model="dialogCargarFormato" persistent max-width="640px">
        <v-card>
          <v-card-title class="headline text-uppercase">
            Cargar formato a la solicitud
          </v-card-title>
          <v-card-text>
            <v-progress-linear v-if="cargandoDetalleFormato" indeterminate color="primary" class="mb-3" />
            <template v-else-if="solicitudCargarFormato">
              <v-simple-table dense class="mb-4">
                <tbody>
                  <tr>
                    <td class="font-weight-bold" width="40%">FOLIO</td>
                    <td>{{ solicitudCargarFormato.folio || '—' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">TIPO</td>
                    <td>{{ solicitudCargarFormato.tipo_permiso || '—' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">INICIO DISFRUTE</td>
                    <td>{{ solicitudCargarFormato.fecha_inicio_disfrute || '—' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">FIN DISFRUTE</td>
                    <td>{{ solicitudCargarFormato.fecha_fin_disfrute || '—' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">REINCORPORACIÓN</td>
                    <td>{{ solicitudCargarFormato.fecha_reincorporacion || '—' }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">DÍAS HÁBILES</td>
                    <td>{{ solicitudCargarFormato.num_dias_habiles_solicitados || '—' }}</td>
                  </tr>
                  <tr v-if="solicitudCargarFormato.observaciones">
                    <td class="font-weight-bold">OBSERVACIONES</td>
                    <td>{{ solicitudCargarFormato.observaciones }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
              <p class="text-body-2 mb-3">
                Descargue el formato, consiga las firmas y adjunte aquí el PDF firmado.
              </p>
              <v-file-input
                v-model="archivoFormatoFirmado"
                accept=".pdf,application/pdf"
                label="Formato firmado (PDF)"
                prepend-icon="mdi-file-pdf-box"
                show-size
                :error-messages="errorArchivoFormato"
                @change="validarArchivoFormato"
              />
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="grey darken-1" @click="cerrarModalCargarFormato">
              CANCELAR
            </v-btn>
            <v-btn
              color="primary"
              text
              :loading="enviandoFormatoFirmado"
              :disabled="cargandoDetalleFormato || !solicitudCargarFormato || enviandoFormatoFirmado"
              @click="confirmarCargarFormato"
            >
              CARGAR
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000">
        {{ snackbar.text }}
      </v-snackbar>
    </v-container>

    <v-container
      fluid
      tag="section"
      class="mt-4 bg-white border rounded shadow text-center solicitudes-permisos-page"
      v-else
    >
      <h2 class="title">Acceso restringido</h2>
      <p class="subtitle">{{ mensajeAccesoRestringido }}</p>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SolicitarPermisoDisfrute from './Solicitar_permiso_disfrute.vue'
import { obtenerSaldosPorConcepto } from '@/utils/saldosPermisoDisfrute'

const MAX_FORMATO_PDF_BYTES = 5 * 1024 * 1024

export default {
  components: {
    SolicitarPermisoDisfrute,
  },
  data () {
    return {
      mostrarFormulario: false,
      idSolicitudEditar: null,
      solicitudEditar: null,
      motivoRechazo: null,
      loading: true,
      dataSolicitudes: [],
      showTable: false,
      datos_empleado: {},
      dialogCargarFormato: false,
      cargandoDetalleFormato: false,
      enviandoFormatoFirmado: false,
      solicitudCargarFormato: null,
      archivoFormatoFirmado: null,
      errorArchivoFormato: [],
      catalogos: {
        tipos: [],
        periodos: [],
        inhabiles: [],
        dias_solicitados: [],
        anio: new Date().getFullYear(),
      },
      columns: [
        'folio',
        'tipo_permiso',
        'fecha_inicio_disfrute',
        'fecha_fin_disfrute',
        'num_dias_habiles_solicitados',
        'estatus',
        'acciones',
      ],
      options: {
        headings: {
          folio: 'FOLIO',
          tipo_permiso: 'TIPO',
          fecha_inicio_disfrute: 'INICIO',
          fecha_fin_disfrute: 'FIN',
          num_dias_habiles_solicitados: 'DÍAS HÁBILES',
          estatus: 'ESTATUS',
          acciones: 'ACCIONES',
        },
        sortable: [
          'folio',
          'tipo_permiso',
          'fecha_inicio_disfrute',
          'fecha_fin_disfrute',
          'num_dias_habiles_solicitados',
          'estatus',
        ],
        texts: {
          count: 'Mostrando del {from} al {to} de {count} registros|{count} resultados|1 resultado',
          filter: 'Buscar:',
          filterPlaceholder: 'Buscar...',
          limit: 'Resultados:',
          recordsDisplay: 'Resultados',
          page: 'Página:',
          noResults: 'No hay resultados',
          filterBy: 'Buscar...',
          loading: 'Cargando...',
          defaultOption: 'Seleccionar {column}',
        },
        filterByColumn: true,
        resizableColumns: false,
        sendEmptyFilters: false,
        perPage: 5,
        perPageValues: [5, 10, 15, 20],
        filterable: [
          'folio',
          'tipo_permiso',
          'fecha_inicio_disfrute',
          'fecha_fin_disfrute',
          'num_dias_habiles_solicitados',
          'estatus',
        ],
      },
      snackbar: {
        show: false,
        text: '',
        color: 'success',
      },
    }
  },
  computed: {
    ...mapState(['user', 'token', 'baseUrl', 'solicitudesPermisosPortal']),
    accesoPermitido () {
      const portal = this.solicitudesPermisosPortal
      if (portal.loaded && portal.pilotActivo && !portal.permitido) {
        return false
      }
      if (!this.datos_empleado || !this.datos_empleado.id_empleado) {
        return false
      }
      const tipo = Number(this.datos_empleado.id_tipo_trabajador)
      const estado = Number(this.datos_empleado.id_estado_empleado)
      const esBaseOConfianza = tipo === 1 || tipo === 2
      if (this.tiposPermisoHabilitados) {
        if (this.tiposPermisoHabilitados.length === 0) {
          return false
        }
      } else if (!esBaseOConfianza && !this.esEventualJubilado) {
        return false
      }
      if (estado === 3 || estado === 8) {
        return false
      }
      if (this.datos_empleado.esta_en_proceso_administrativo === true) {
        return false
      }
      return true
    },
    mensajeAccesoRestringido () {
      const portal = this.solicitudesPermisosPortal
      if (portal.loaded && portal.pilotActivo && !portal.permitido) {
        return 'El módulo de solicitudes de permisos está en prueba. Tu usuario aún no tiene acceso.'
      }
      if (this.datos_empleado && this.datos_empleado.esta_en_proceso_administrativo === true) {
        return 'No puedes solicitar permisos mientras estés en proceso administrativo.'
      }
      return 'No tienes permisos para acceder a esta sección.'
    },
    hayConceptosDisponibles () {
      return (this.catalogos.tipos || []).some((tipo) => this.tipoEsVisible(tipo))
    },
    puedeSolicitar () {
      return this.accesoPermitido && !this.loading && this.hayConceptosDisponibles
    },
    saldosPorConcepto () {
      return obtenerSaldosPorConcepto(this.catalogos.tipos, this.catalogos.periodos)
    },
    esEventualJubilado () {
      if (!this.datos_empleado) {
        return false
      }
      return Number(this.datos_empleado.id_tipo_trabajador) === 3
        && this.datos_empleado.tipo_eventual === 'jubilado'
    },
    esElegibleDiasEconomicos () {
      if (!this.datos_empleado) {
        return false
      }
      const tipo = Number(this.datos_empleado.id_tipo_trabajador)
      return tipo === 1 || tipo === 2 || this.esEventualJubilado
    },
    // Configuración por tipo de permiso y categoría de empleado (API nuevo); null con el API anterior
    tiposPermisoHabilitados () {
      const lista = this.datos_empleado && this.datos_empleado.tipos_permiso_habilitados
      return Array.isArray(lista) ? lista.map(Number) : null
    },
  },
  async mounted () {
    await this.$store.dispatch('cargarSolicitudesPermisosPortalPilot')
    await this.obtenerDatosEmpleado()
    if (this.accesoPermitido) {
      this.loading = true
      try {
        await Promise.all([
          this.cargarCatalogos(),
          this.getSolicitudesEmpleado(true),
        ])
      } finally {
        this.loading = false
        this.showTable = true
      }
    } else {
      this.loading = false
    }
  },
  methods: {
    tieneAccionesDisponibles (row) {
      const estatus = Number(row.id_estatus)
      return estatus === 1 || estatus === 3 || estatus === 4
    },
    puedeEliminarSolicitud (row) {
      const estatus = Number(row && row.id_estatus)
      return estatus === 1 || estatus === 4
    },
    async eliminarSolicitud (row) {
      const idSolicitud = Number(row && (row.id_solicitud || row.id))
      if (!idSolicitud) {
        return
      }
      const confirmar = await this.$swal({
        className: 'text-center',
        title: '¿DESEA ELIMINAR ESTA SOLICITUD?',
        text: 'Los días reservados volverán a estar disponibles.',
        icon: 'warning',
        allowEscapeKey: false,
        allowOutsideClick: false,
        reverseButtons: true,
        buttons: ['Cancelar', 'Aceptar'],
      })
      if (!confirmar) {
        return
      }
      try {
        const response = await this.$http.post('post-empleado-solicitud-permiso-eliminar', {
          id_solicitud: idSolicitud,
        })
        if (!response.data || !response.data.response) {
          throw new Error(
            (response.data && response.data.message) || 'No se pudo eliminar la solicitud'
          )
        }
        await this.getSolicitudesEmpleado()
        this.$swal({
          title: 'Solicitud eliminada',
          text: response.data.message || 'La solicitud se eliminó correctamente.',
          icon: 'success',
          button: 'Aceptar',
        })
      } catch (error) {
        const data = error && error.response && error.response.data
        this.$swal({
          title: (data && data.message) || error.message || 'Ocurrió un problema al eliminar la solicitud',
          icon: 'error',
          button: 'Aceptar',
        })
      }
    },
    generar_formato_solicitud_permiso (row) {
      const form = document.createElement('form')
      form.target = '_blank'
      form.method = 'post'
      form.id = 'form-formato-solicitud-permiso'
      form.action = `${this.baseUrl}post-empleado-solicitud-permiso-formato?token=${this.token}`

      const idSolicitud = document.createElement('input')
      idSolicitud.type = 'hidden'
      idSolicitud.name = 'id_solicitud'
      idSolicitud.value = row.id_solicitud
      form.append(idSolicitud)

      const idEmpleado = document.createElement('input')
      idEmpleado.type = 'hidden'
      idEmpleado.name = 'id_empleado'
      idEmpleado.value = this.user.id_empleado
      form.append(idEmpleado)

      document.body.append(form)
      form.submit()
      document.body.removeChild(form)
    },
    async abrirModalCargarFormato (row) {
      this.dialogCargarFormato = true
      this.cargandoDetalleFormato = true
      this.solicitudCargarFormato = { ...row }
      this.archivoFormatoFirmado = null
      this.errorArchivoFormato = []

      try {
        const response = await this.$http.get(
          'solicitudes-permisos/detalle/' + row.id_solicitud,
          { params: { id_empleado: this.user.id_empleado } }
        )
        if (response.data && response.data.response && response.data.data) {
          this.solicitudCargarFormato = response.data.data
        }
      } catch (error) {
        this.$swal({
          title: 'No se pudo cargar el detalle de la solicitud',
          icon: 'error',
          button: 'Aceptar',
        })
        this.cerrarModalCargarFormato()
      } finally {
        this.cargandoDetalleFormato = false
      }
    },
    cerrarModalCargarFormato () {
      this.dialogCargarFormato = false
      this.cargandoDetalleFormato = false
      this.solicitudCargarFormato = null
      this.archivoFormatoFirmado = null
      this.errorArchivoFormato = []
    },
    validarArchivoFormato () {
      this.errorArchivoFormato = []
      const archivo = this.obtenerArchivoFormato()
      if (!archivo) {
        return false
      }
      const esPdf = archivo.type === 'application/pdf' || /\.pdf$/i.test(archivo.name || '')
      if (!esPdf) {
        this.errorArchivoFormato = ['Solo se permiten archivos PDF.']
        return false
      }
      if (archivo.size > MAX_FORMATO_PDF_BYTES) {
        this.errorArchivoFormato = ['El archivo no debe superar 5 MB.']
        return false
      }
      return true
    },
    obtenerArchivoFormato () {
      if (!this.archivoFormatoFirmado) {
        return null
      }
      if (Array.isArray(this.archivoFormatoFirmado)) {
        return this.archivoFormatoFirmado[0] || null
      }
      return this.archivoFormatoFirmado
    },
    confirmarCargarFormato () {
      const archivo = this.obtenerArchivoFormato()
      if (!archivo) {
        this.errorArchivoFormato = ['Debe seleccionar el PDF firmado.']
        return
      }
      if (!this.validarArchivoFormato()) {
        return
      }

      const solicitud = this.solicitudCargarFormato
      const idSolicitud = solicitud.id_solicitud || solicitud.id
      if (!idSolicitud) {
        this.$swal({
          title: 'No se pudo identificar la solicitud',
          icon: 'error',
          button: 'Aceptar',
        })
        return
      }

      const form = new FormData()
      form.append('id_solicitud', idSolicitud)
      form.append('id_empleado', this.user.id_empleado)
      form.append('archivo', archivo)

      this.enviandoFormatoFirmado = true
      this.$http.post('post-empleado-solicitud-permiso-cargar-formato', form)
        .then(async (response) => {
          if (!response.data || !response.data.response) {
            throw new Error(
              (response.data && response.data.message) || 'No se pudo cargar el formato firmado'
            )
          }
          this.cerrarModalCargarFormato()
          await this.getSolicitudesEmpleado()
          this.$swal({
            title: 'Formato cargado',
            text: response.data.message || 'Su solicitud fue enviada a recursos humanos.',
            icon: 'success',
            button: 'Aceptar',
          })
        })
        .catch((error) => {
          const data = error && error.response && error.response.data
          this.$swal({
            title: (data && data.message) || error.message || 'Ocurrió un problema al cargar el formato',
            icon: 'error',
            button: 'Aceptar',
          })
        })
        .finally(() => {
          this.enviandoFormatoFirmado = false
        })
    },
    tieneAntiguedad6Meses () {
      return this.datos_empleado && this.datos_empleado.ya_tiene_antiguedad_6_meses === true
    },
    esElegibleCuatrimestre () {
      if (!this.datos_empleado) {
        return false
      }
      if (this.datos_empleado.elegible_cuatrimestre === true) {
        return true
      }
      return this.datos_empleado.elegible_extraordinarios === true
    },
    esElegibleAniosServicio () {
      if (!this.datos_empleado) {
        return false
      }
      return this.datos_empleado.elegible_anios_servicio === true
    },
    puedeUsarTipo (tipo) {
      if (!tipo) return false
      if (this.tiposPermisoHabilitados) {
        if (!this.tiposPermisoHabilitados.includes(Number(tipo.id))) {
          return false
        }
      } else if (this.esEventualJubilado && tipo.clave !== 'dias_economicos') {
        return false
      }
      // Antigüedad mínima por tipo (meses, catálogo de reglas); con el API anterior, 6 meses en vacaciones y días económicos
      const antiguedadCumplida = Array.isArray(this.datos_empleado && this.datos_empleado.tipos_permiso_antiguedad_cumplida)
        ? this.datos_empleado.tipos_permiso_antiguedad_cumplida.map(Number).includes(Number(tipo.id))
        : null
      if (antiguedadCumplida === false) {
        return false
      }
      if (tipo.clave === 'dias_economicos') {
        return (this.tiposPermisoHabilitados ? true : this.esElegibleDiasEconomicos)
          && (antiguedadCumplida === true || this.tieneAntiguedad6Meses())
      }
      if (tipo.clave === 'vacaciones') {
        return antiguedadCumplida === true || this.tieneAntiguedad6Meses()
      }
      if (tipo.clave === 'cuatrimestre') {
        return this.esElegibleCuatrimestre()
      }
      if (tipo.clave === 'anios_servicio') {
        return this.esElegibleAniosServicio()
      }
      return true
    },
    tipoEsVisible (tipo) {
      if (!this.puedeUsarTipo(tipo)) {
        return false
      }
      if (Number(tipo.requiere_periodo) === 1) {
        const periodos = (this.catalogos.periodos || []).filter((p) => {
          if (Number(p.id_tipo_permiso) !== Number(tipo.id)) {
            return false
          }
          return Number(p.dias_disponibles) > 0 && Number(p.saldo_activo) !== 0
        })
        return periodos.length > 0
      }
      return true
    },
    async obtenerDatosEmpleado () {
      try {
        const response = await this.$http.get(
          'solicitudes-permisos/datos-empleado/' + this.user.id_empleado
        )
        if (response.data && response.data.response) {
          this.datos_empleado = response.data.data || {}
        } else {
          this.datos_empleado = {}
        }
      } catch (error) {
        this.datos_empleado = {}
      }
    },
    async cargarCatalogos () {
      try {
        const anio = new Date().getFullYear()
        const response = await this.$http.get('solicitudes-permisos/obtener-catalogos', {
          params: {
            anio,
            anio_hasta: anio + 1,
            id_empleado: this.user && this.user.id_empleado ? this.user.id_empleado : undefined,
          },
        })
        if (response.data && response.data.response) {
          this.catalogos = Object.assign({
            tipos: [],
            periodos: [],
            inhabiles: [],
            dias_solicitados: [],
            anio,
          }, response.data.data || {})
        }
      } catch (error) {
        // catálogos se reintentan al abrir el formulario
      }
    },
    async getSolicitudesEmpleado (omitirLoading = false) {
      try {
        const response = await this.$http.get(
          'get-solicitudes-permisos/' + this.user.id_empleado
        )
        this.dataSolicitudes = Array.isArray(response.data.data)
          ? response.data.data
          : []
        this.showTable = true
      } catch (error) {
        this.dataSolicitudes = []
        this.showTable = true
      } finally {
        if (!omitirLoading) {
          this.loading = false
        }
      }
    },
    async recargarDatosCompletos () {
      this.loading = true
      this.showTable = false
      try {
        await Promise.all([
          this.obtenerDatosEmpleado(),
          this.cargarCatalogos(),
          this.getSolicitudesEmpleado(true),
        ])
      } finally {
        this.loading = false
        this.showTable = true
      }
    },
    async solicitarPermisoVista () {
      this.loading = true
      this.showTable = false
      this.idSolicitudEditar = null
      this.solicitudEditar = null
      this.motivoRechazo = null
      await this.$nextTick()
      try {
        await Promise.all([
          this.obtenerDatosEmpleado(),
          this.cargarCatalogos(),
        ])
        this.mostrarFormulario = true
      } finally {
        this.loading = false
      }
    },
    async editarSolicitud (row) {
      this.loading = true
      this.showTable = false
      await this.$nextTick()
      try {
        const [detalleResponse] = await Promise.all([
          this.$http.get(
            'solicitudes-permisos/detalle/' + row.id_solicitud,
            { params: { id_empleado: this.user.id_empleado } }
          ),
          this.obtenerDatosEmpleado(),
          this.cargarCatalogos(),
        ])

        if (!detalleResponse.data || !detalleResponse.data.response) {
          this.$swal({
            title: (detalleResponse.data && detalleResponse.data.message) || 'No se pudo cargar la solicitud',
            icon: 'error',
            button: 'Aceptar',
          })
          this.showTable = true
          return
        }

        this.idSolicitudEditar = row.id_solicitud
        this.solicitudEditar = detalleResponse.data.data
        this.motivoRechazo = detalleResponse.data.data.motivo_rechazo || row.motivo_rechazo || null
        this.mostrarFormulario = true
      } catch (error) {
        this.$swal({
          title: 'Ocurrió un problema al cargar la solicitud',
          icon: 'error',
          button: 'Aceptar',
        })
        this.showTable = true
      } finally {
        this.loading = false
      }
    },
    async manejarRegresarFormulario (payload = {}) {
      const solicitudExitosa = payload && payload.solicitudExitosa === true
      this.mostrarFormulario = false
      this.idSolicitudEditar = null
      this.solicitudEditar = null
      this.motivoRechazo = null

      if (solicitudExitosa) {
        await this.recargarDatosCompletos()
        this.$swal({
          title: 'Solicitud guardada',
          text: 'Debe generar el formato de uso múltiple desde el menú de acciones, conseguir las firmas y cargar el PDF firmado para enviar su solicitud a recursos humanos.',
          icon: 'success',
          button: 'Aceptar',
        })
      } else {
        this.loading = true
        this.showTable = false
        await this.getSolicitudesEmpleado()
      }
    },
  },
}
</script>

<style>
.solicitudes-permisos-page {
  min-height: calc(100vh - 110px);
}

.solicitudes-permisos-loading {
  min-height: calc(100vh - 260px);
}
</style>
